import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import { App } from "./App.jsx";
import stylesheetURL from "../assets/stylesheets/index.css?url";

function assetURL(absolutePath) {
  if (import.meta.env.DEV) {
    return new URL(absolutePath, import.meta.url);
  }

  const relativePath = `.${absolutePath}`;
  return new URL(relativePath, import.meta.url);
}

export class AmaiDiscussit extends HTMLElement {
  static tagName = "amai-discussit";

  static register(tagName = this.tagName, registry) {
    if ("customElements" in window) {
      (registry || customElements).define(tagName, this);
    }
  }

  static get observedAttributes() {
    return ["src", "kiosk"];
  }

  #shadowRoot = null;
  #root = null;

  connectedCallback() {
    if (this.#shadowRoot === null) {
      this.#shadowRoot = this.attachShadow({ mode: "closed" });
    }
    this.renderApp();
  }

  disconnectedCallback() {
    this.#root?.unmount();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    // kiosk is a boolean attribute, so adding it goes from null and must still re-render.
    const changed = name === "kiosk" || oldValue !== null;
    if (changed && oldValue !== newValue && this.isConnected && this.#root) {
      this.renderApp();
    }
  }

  renderApp() {
    const src = this.getAttribute("src");

    if (!src) {
      throw new Error("The 'src' attribute is required.");
    }
    // On unless missing or "false", so a typo errs on the private side.
    const kiosk =
      this.hasAttribute("kiosk") && this.getAttribute("kiosk") !== "false";

    if (!this.#root) {
      this.#root = ReactDOM.createRoot(
        this.#shadowRoot,
        import.meta.env.PROD
          ? {
              onUncaughtError: Sentry.reactErrorHandler(),
              onCaughtError: Sentry.reactErrorHandler(),
              onRecoverableError: Sentry.reactErrorHandler(),
            }
          : {},
      );
    }
    const stylesheet = assetURL(stylesheetURL);
    this.#root.render(
      <>
        <link rel="stylesheet" href={stylesheet.href} />
        {/* To prevent FOUC, we hide the element itself until our CSS is loaded */}
        <style>{":where(:host) { visibility: hidden; }"}</style>
        <App src={src} kiosk={kiosk} />
      </>,
    );
  }
}
